import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout, getParentLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { NO_RESET_WHITE_LIST } from '@/constants'

const { t } = useI18n()

// 基础路由配置
export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/booth-list/index',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'RedirectWrap',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/qywx-system-entry',
    component: () => import('@/views/QywxSystemEntry/QywxSystemEntry.vue'),
    name: 'QywxSystemEntry',
    meta: {
      hidden: true,
      title: '选择系统',
      noTagsView: true
    }
  },
  // 新用户注册
  {
    path: '/register',
    component: () => import('@/views/Login/Register.vue'),
    name: 'Register',
    meta: {
      hidden: true,
      title: '注册',
      noTagsView: true
    }
  },
  {
    path: '/personal',
    component: Layout,
    redirect: '/personal/personal-center',
    name: 'Personal',
    meta: {
      title: t('router.personal'),
      hidden: true,
      canTo: true
    },
    children: [
      {
        path: 'personal-center',
        component: () => import('@/views/Personal/PersonalCenter/PersonalCenter.vue'),
        name: 'PersonalCenter',
        meta: {
          title: t('router.personalCenter'),
          hidden: true,
          canTo: true
        }
      }
    ]
  },
  {
    path: '/404',
    component: Layout,
    meta: {
      hidden: true,
      noTagsView: true
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Error/404.vue'),
        name: 'NoFind',
        meta: {
          hidden: true,
          title: '404',
          noTagsView: true,
          breadcrumb: false
        }
      }
    ]
  }
]

// 本地路由配置
export const asyncRouterMap: AppRouteRecordRaw[] = [
  // {
  //   path: '/booth-list-mobile',
  //   component: () => import('@/views/BoothList/BoothListMobile.vue'),
  //   name: 'BoothListMobile',
  //   meta: {
  //     hidden: true,
  //     title: '座位列表',
  //     noTagsView: true
  //   }
  // }
  // {
  //   path: '/booth-list',
  //   component: Layout,
  //   name: 'BoothList',
  //   meta: {},
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/BoothList/BoothList.vue'),
  //       name: 'BoothListIndex',
  //       meta: {
  //         title: '座位列表',
  //         icon: 'vi-solar:armchair-2-bold'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/audit-management',
  //   component: Layout,
  //   name: 'AuditManagement',
  //   meta: {},
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/AuditManagement/AuditManagement.vue'),
  //       name: 'AuditManagementIndex',
  //       meta: {
  //         title: '审核管理',
  //         icon: 'vi-solar:checklist-minimalistic-bold'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/liquor-access',
  //   component: Layout,
  //   name: 'LiquorAccess',
  //   meta: {},
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/LiquorAccess/LiquorAccess.vue'),
  //       name: 'LiquorAccessIndex',
  //       meta: {
  //         title: '存取酒管理',
  //         icon: 'vi-solar:wineglass-triangle-bold'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/operation-log',
  //   component: Layout,
  //   name: 'OperationLog',
  //   meta: {},
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/OperationLog/OperationLog.vue'),
  //       name: 'OperationLogIndex',
  //       meta: {
  //         title: '操作日志',
  //         icon: 'vi-solar:reorder-bold'
  //       }
  //     }
  //   ]
  // },
]

const router = createRouter({
  history: createWebHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
